var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximumNumberExceededCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 610,
    height: 610,
    viewBox: "0 0 610 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47878",
    "data-name": "Path 47878",
    d: "M167.966,287.068s-79.113,23.968-79.113,28.463-2.266,93.133-.46,98.15,16.734,9.936,24.877,9.936v1.818h173.6L278.305,377.5s48.832-1.818,49.681-5.429-42.834-75.927-46.906-78.2-66.087-9.052-73.321-9.052S185.148,281.6,167.966,287.068Z",
    transform: "translate(-87.694 -283.876)",
    fill: "#4b4e6d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47886",
    "data-name": "Path 47886",
    d: "M148.72,288.446s6.325,15.825,13.111,29.384,23.023,32.559,27.13,28.488,8.131-35.722,8.131-42.956v-21.7s-12.65,10.4-22.6,10.4S148.72,288.446,148.72,288.446Z",
    transform: "translate(-148.72 -281.66)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47904",
    "data-name": "Path 47904",
    d: "M138.216,262.26s-11.305,20.345-9.5,23.507,19.9,22.611,19.9,22.611S97.066,385.238,92.1,392.92s-5.877,18.988-3.635,25.325,15.825,12.2,25.325,11.754,16.722-12.214,19.388-23.023,27.191-90.5,29.457-96.792,5.416-11.305,2.254-14.468S149.521,280.8,149.521,280.8s3.635-3.163,3.163-6.786S144.541,263.157,138.216,262.26Z",
    transform: "translate(-87.304 -262.26)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47911",
    "data-name": "Path 47911",
    d: "M201.507,333.419s-35.722,29.4-40.69,32.1-2.714,7.694-.909,9.5,13.559,12.663,18.988,16.273,13.111-2.714,14.916-3.635-.448-4.98-.448-4.98,14.02-7.682,16.273-14.916a81.67,81.67,0,0,0,2.714-17.182S269.3,373.6,282.886,378.6s22.15,5.429,28.488-.9,6.774-19.448,3.635-26.222-23.023-13.111-32.1-13.111-73.249-7.694-77.308-6.337Z",
    transform: "translate(-157.799 -331.878)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8683",
    "data-name": "Group 8683",
    transform: "translate(-231 -237)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12894",
    "data-name": "Rectangle 12894",
    width: 610,
    height: 610,
    transform: "translate(231 237)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_504_Error_Gateway_Timeout-bro",
    "data-name": "504 Error Gateway Timeout-bro",
    transform: "translate(236.39 269.072)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-16",
    transform: "translate(59.814 75.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47846",
    "data-name": "Path 47846",
    d: "M57.26,344.848s8.579,74.8,72.146,106.753,125.825.872,182.97-6.616c29.93-3.926,57.69,10.8,87.05,13.874,93.848,9.851,167.509-100.743,154.289-182.1-11.439-70.437-56.442-120.142-138.451-155.622S276.848,57.452,181.595,90.847,50.474,248.007,57.26,344.848Z",
    transform: "translate(-56.459 -75.928)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47847",
    "data-name": "Path 47847",
    d: "M57.26,344.848s8.579,74.8,72.146,106.753,125.825.872,182.97-6.616c29.93-3.926,57.69,10.8,87.05,13.874,93.848,9.851,167.509-100.743,154.289-182.1-11.439-70.437-56.442-120.142-138.451-155.622S276.848,57.452,181.595,90.847,50.474,248.007,57.26,344.848Z",
    transform: "translate(-56.459 -75.928)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16",
    transform: "translate(289.837 289.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47848",
    "data-name": "Path 47848",
    d: "M389.063,366l20.115,32.4a6.2,6.2,0,0,1-5.271,9.476H362.829a6.2,6.2,0,0,0,5.271-9.451l-19.46-31.7Z",
    transform: "translate(-224.62 -228.106)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47849",
    "data-name": "Path 47849",
    d: "M389.073,365.98l-40.423.727,7.488,12.19h40.944Z",
    transform: "translate(-224.618 -228.11)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12868",
    "data-name": "Rectangle 12868",
    width: 171.798,
    height: 145.092,
    rx: 2.91,
    transform: "translate(225.09 145.092) rotate(180)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12869",
    "data-name": "Rectangle 12869",
    width: 171.798,
    height: 145.092,
    rx: 2.91,
    transform: "translate(218.595 145.092) rotate(180)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47850",
    "data-name": "Path 47850",
    d: "M290.678,252.2h160.25a5.768,5.768,0,0,1,5.78,5.768V371.3H284.91V258.016a5.768,5.768,0,0,1,5.768-5.816Z",
    transform: "translate(-238.113 -252.2)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12870",
    "data-name": "Rectangle 12870",
    width: 157.366,
    height: 105.396,
    transform: "translate(211.675 111.528) rotate(180)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12871",
    "data-name": "Rectangle 12871",
    width: 4.992,
    height: 1.66,
    transform: "translate(2.581 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12872",
    "data-name": "Rectangle 12872",
    width: 4.992,
    height: 1.66,
    transform: "translate(9.245 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12873",
    "data-name": "Rectangle 12873",
    width: 4.992,
    height: 1.66,
    transform: "translate(15.91 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12874",
    "data-name": "Rectangle 12874",
    width: 4.992,
    height: 1.66,
    transform: "translate(22.574 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12875",
    "data-name": "Rectangle 12875",
    width: 4.992,
    height: 1.66,
    transform: "translate(29.239 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12876",
    "data-name": "Rectangle 12876",
    width: 4.992,
    height: 1.66,
    transform: "translate(35.903 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12877",
    "data-name": "Rectangle 12877",
    width: 4.992,
    height: 1.66,
    transform: "translate(42.568 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12878",
    "data-name": "Rectangle 12878",
    width: 4.992,
    height: 1.66,
    transform: "translate(49.232 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12879",
    "data-name": "Rectangle 12879",
    width: 4.992,
    height: 1.66,
    transform: "translate(55.897 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12880",
    "data-name": "Rectangle 12880",
    width: 4.992,
    height: 1.66,
    transform: "translate(62.561 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12881",
    "data-name": "Rectangle 12881",
    width: 4.992,
    height: 1.66,
    transform: "translate(69.226 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12882",
    "data-name": "Rectangle 12882",
    width: 4.992,
    height: 1.66,
    transform: "translate(75.89 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12883",
    "data-name": "Rectangle 12883",
    width: 4.992,
    height: 1.66,
    transform: "translate(82.555 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12884",
    "data-name": "Rectangle 12884",
    width: 4.992,
    height: 1.66,
    transform: "translate(89.207 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12885",
    "data-name": "Rectangle 12885",
    width: 4.992,
    height: 1.66,
    transform: "translate(95.872 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12886",
    "data-name": "Rectangle 12886",
    width: 4.992,
    height: 1.66,
    transform: "translate(102.536 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12887",
    "data-name": "Rectangle 12887",
    width: 4.992,
    height: 1.66,
    transform: "translate(109.2 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12888",
    "data-name": "Rectangle 12888",
    width: 4.992,
    height: 1.66,
    transform: "translate(115.865 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12889",
    "data-name": "Rectangle 12889",
    width: 4.992,
    height: 1.66,
    transform: "translate(122.529 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12890",
    "data-name": "Rectangle 12890",
    width: 4.992,
    height: 1.66,
    transform: "translate(129.194 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12891",
    "data-name": "Rectangle 12891",
    width: 4.992,
    height: 1.66,
    transform: "translate(135.858 172.489)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12892",
    "data-name": "Rectangle 12892",
    width: 144.498,
    height: 5.392,
    transform: "translate(0 174.391)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12893",
    "data-name": "Rectangle 12893",
    width: 35.249,
    height: 5.392,
    transform: "translate(109.249 174.391)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47914",
    "data-name": "Path 47914",
    d: "M371.3,330.9v-2.908c0-14.974,18.958-15.625,18.958-26.284,0-4.627-3.767-7.647-9.375-7.647-6.137,0-10.017,3.342-10.017,8.081v1.189c0,1.181-.642,1.736-1.832,1.736l-11.519-.434c-1.076,0-1.832-.538-1.832-1.285V302.16c0-13.02,10.338-21.97,25.529-21.97,14.861,0,24.444,8.4,24.444,21,0,17.882-19.279,17.994-19.279,27.777V330.9a1.649,1.649,0,0,1-1.831,1.832H373.128A1.649,1.649,0,0,1,371.3,330.9Zm-.972,17.361c0-4.739,4.2-8.62,9.262-8.62,4.852,0,9.158,3.88,9.158,8.62s-4.34,8.62-9.262,8.62-9.158-3.9-9.158-8.637Z",
    transform: "translate(-248.976 -259.705)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16",
    transform: "translate(40.61 213.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47873",
    "data-name": "Path 47873",
    d: "M192.609,248.926s6.192-10.7,8.482-6.192,1.7,14.068-1.684,18.576-4.508,6.749-6.192,3.369S192.609,248.926,192.609,248.926Z",
    transform: "translate(-8.5 -177.991)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47874",
    "data-name": "Path 47874",
    d: "M133.316,255.481s-7.27-9-9.015-2.811,6.761,14.068,9.015,15.2a10.906,10.906,0,0,0,5.622.57Z",
    transform: "translate(-22.94 -176.113)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47875",
    "data-name": "Path 47875",
    d: "M167.966,287.068s-79.113,23.968-79.113,28.463-2.266,93.133-.46,98.15,16.734,9.936,24.877,9.936v1.818h173.6L278.305,377.5s48.832-1.818,49.681-5.429-42.834-75.927-46.906-78.2-66.087-9.052-73.321-9.052S185.148,281.6,167.966,287.068Z",
    transform: "translate(-30.641 -169.046)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8679",
    "data-name": "Group 8679",
    transform: "translate(57.052 114.831)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47876",
    "data-name": "Path 47876",
    d: "M236.981,411.316C127.356,371.027,132.252,350.5,132.252,350.5L95.9,406.057a47.256,47.256,0,0,0,15.655,3.441v1.818Z",
    transform: "translate(-85.956 -269.771)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47877",
    "data-name": "Path 47877",
    d: "M190.126,309.4s37.212-1.963,61.689-19.581L183.28,281Z",
    transform: "translate(-67.456 -284.486)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47879",
    "data-name": "Path 47879",
    d: "M167.966,287.068s-79.113,23.968-79.113,28.463-2.266,93.133-.46,98.15,16.734,9.936,24.877,9.936v1.818h173.6L278.305,377.5s48.832-1.818,49.681-5.429-42.834-75.927-46.906-78.2-66.087-9.052-73.321-9.052S185.148,281.6,167.966,287.068Z",
    transform: "translate(-30.641 -169.046)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_509",
    "data-name": "Line 509",
    x1: 12.965,
    y1: 38.884,
    transform: "translate(233.148 147.297)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47880",
    "data-name": "Path 47880",
    d: "M101.08,311.38S122.685,323.5,129.6,352",
    transform: "translate(-27.807 -163.223)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47881",
    "data-name": "Path 47881",
    d: "M104.583,355.91s-14.468,9.5-17.631,11.754-4.071,26.234-.909,33.007,16.734,9.948,25.773,5.429,13.111-25.773,9.948-36.618S104.583,355.91,104.583,355.91Z",
    transform: "translate(-31.407 -153.795)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47882",
    "data-name": "Path 47882",
    d: "M144.62,292.265s1.357,21.7,5.416,36.17S161.79,361.89,161.79,361.89l25.773-20.345,34.813,8.591s-6.774-35.709-11.754-47.463-14.916-21.254-14.916-21.254S157.731,276.44,144.62,292.265Z",
    transform: "translate(-18.589 -169.723)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47883",
    "data-name": "Path 47883",
    d: "M148.72,288.446s6.325,15.825,13.111,29.384,23.023,32.559,27.13,28.488,8.131-35.722,8.131-42.956v-21.7s-12.65,10.4-22.6,10.4S148.72,288.446,148.72,288.446Z",
    transform: "translate(-17.721 -169.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8680",
    "data-name": "Group 8680",
    transform: "translate(130.999 112.145)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47884",
    "data-name": "Path 47884",
    d: "M197.092,281.66s-12.65,10.4-22.6,10.4-25.773-3.635-25.773-3.635,3.211,8.034,7.513,17.558a37.794,37.794,0,0,0,26.452,5.937c5.671-.9,10.421-3.987,14.407-8.252Z",
    transform: "translate(-148.72 -281.66)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47885",
    "data-name": "Path 47885",
    d: "M197.092,281.66s-12.65,10.4-22.6,10.4-25.773-3.635-25.773-3.635,3.211,8.034,7.513,17.558a37.794,37.794,0,0,0,26.452,5.937c5.671-.9,10.421-3.987,14.407-8.252Z",
    transform: "translate(-148.72 -281.66)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47887",
    "data-name": "Path 47887",
    d: "M148.72,288.446s6.325,15.825,13.111,29.384,23.023,32.559,27.13,28.488,8.131-35.722,8.131-42.956v-21.7s-12.65,10.4-22.6,10.4S148.72,288.446,148.72,288.446Z",
    transform: "translate(-17.721 -169.515)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47888",
    "data-name": "Path 47888",
    d: "M130.487,258.9s9.573,31.5,15.752,39.987,23.083,16.891,35.467,16.322,22.514-12.941,24.768-25.325.557-40.532.557-40.532-2.242-12.384-11.814-28.706-57.981-2.823-63.01,9.56S130.487,258.9,130.487,258.9Z",
    transform: "translate(-21.807 -184.027)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47889",
    "data-name": "Path 47889",
    d: "M161.89,271.44s5.635,7.876,12.384-.57",
    transform: "translate(-14.932 -171.8)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47890",
    "data-name": "Path 47890",
    d: "M147.49,261.47s5.065-4.508,11.826,0",
    transform: "translate(-83.833 -121.84) rotate(-16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47891",
    "data-name": "Path 47891",
    d: "M173.51,259.118s2.254-4.508,10.687-4.508",
    transform: "translate(49.894 -208.892) rotate(13)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47892",
    "data-name": "Path 47892",
    d: "M145.17,254.859s3.381-5.622,14.638-6.749",
    transform: "translate(-18.472 -176.618)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47893",
    "data-name": "Path 47893",
    d: "M171.14,253.749s5.477-11.378,15.256-7.84",
    transform: "translate(-12.974 -177.229)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47894",
    "data-name": "Path 47894",
    d: "M173.665,282.488a3.114,3.114,0,1,1-3.126-2.787,2.969,2.969,0,0,1,3.126,2.787Z",
    transform: "translate(-13.754 -169.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47895",
    "data-name": "Path 47895",
    d: "M158.127,262.806a1.709,1.709,0,1,1-1.709-1.7,1.709,1.709,0,0,1,1.709,1.7Z",
    transform: "translate(-19.288 -173.852)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47896",
    "data-name": "Path 47896",
    d: "M182.6,257.559a1.7,1.7,0,1,1-.493-1.207,1.708,1.708,0,0,1,.493,1.207Z",
    transform: "translate(-14.27 -174.247)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47897",
    "data-name": "Path 47897",
    d: "M160.012,195.871h-19.7c-11.257,0-25.895,29.833-25.337,43.9s12.953,23.083,16.334,24.768,9.56,4.508,9.56,2.811,6.761-15.2,6.761-15.2-1.7,7.888,2.811,7.888,18.576-14.638,18.576-14.638.57,11.814,5.065,11.814,14.08-17.449,14.08-17.449l10.13,11.257,3.381-6.749s3.938,15.752,7.27,15.752,6.192-7.888,7.888-15.752,5.065-20.829-.57-32.656-21.944-22.514-35.455-22.514S160.012,195.871,160.012,195.871Z",
    transform: "translate(-24.869 -189.11)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47898",
    "data-name": "Path 47898",
    d: "M151.412,199.509s-13.862,1.6-20.26,5.865a23.411,23.411,0,0,0-8.482,9.6l13.862-6.4s-9.064,6.931-10.13,10.13a87.529,87.529,0,0,0-2.121,10.13l8.482-2.666s-3.526,2.957-3.2,5.865,1.6,9.6,1.6,9.6l10.13-9.6,2.666,6.931,8.482-6.931.533,5.332,5.865-8,4.847,4.847,3.2-5.865s2.666,2.666,3.732-3.732,1.6-9.064,1.6-9.064l5.865,6.931,2.133,9.064,1.6-9.6,4.847,4.265,1.6-8,5.865,3.2,2.133-7.464,12.8,4.265s-3.732-13.329-6.931-17.061-18.661-5.332-18.661-5.332l-1.6-2.666s-18.176,3.732-20.26,4.847a24.235,24.235,0,0,0-4.847,3.732",
    transform: "translate(-23.236 -188.253)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47899",
    "data-name": "Path 47899",
    d: "M119.423,282.105a12.323,12.323,0,0,1-3.163-8.143c0-4.968,5.429-15.752,6.786-15.752s4.059,2.7,4.059,2.7-2.254,10.905-3.163,14.928a11.027,11.027,0,0,1-4.52,6.265Z",
    transform: "translate(-24.593 -174.48)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47900",
    "data-name": "Path 47900",
    d: "M122.27,286.163s-4.52-5.429-4.52-7.682,7.27-18.091,9.039-18.091,7.27,2.266,8.591,3.175.909,5.416.909,8.591-8.143,17.17-8.143,17.17Z",
    transform: "translate(-24.278 -174.018)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47901",
    "data-name": "Path 47901",
    d: "M138.216,262.26s-11.305,20.345-9.5,23.507,19.9,22.611,19.9,22.611S97.066,385.238,92.1,392.92s-5.877,18.988-3.635,25.325,15.825,12.2,25.325,11.754,16.722-12.214,19.388-23.023,27.191-90.5,29.457-96.792,5.416-11.305,2.254-14.468S149.521,280.8,149.521,280.8s3.635-3.163,3.163-6.786S144.541,263.157,138.216,262.26Z",
    transform: "translate(-30.724 -173.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8681",
    "data-name": "Group 8681",
    transform: "translate(56.58 88.638)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47902",
    "data-name": "Path 47902",
    d: "M132.311,403.635c2.714-10.906,27.13-90.431,29.4-96.756s5.416-11.305,2.254-14.468c-2.848-2.848-13.014-12.65-15-14.541h-.073c1.769,2.314,11.124,14.844,10.154,22.09-1.066,8-42.119,104.511-47.451,110.909-4.084,4.847-15,7.9-19.921,9.052a36.037,36.037,0,0,0,21.205,6.786C122.363,426.233,129.633,414.48,132.311,403.635Z",
    transform: "translate(-86.38 -258.955)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47903",
    "data-name": "Path 47903",
    d: "M132.311,403.635c2.714-10.906,27.13-90.431,29.4-96.756s5.416-11.305,2.254-14.468c-2.848-2.848-13.014-12.65-15-14.541h-.073c1.769,2.314,11.124,14.844,10.154,22.09-1.066,8-42.119,104.511-47.451,110.909-4.084,4.847-15,7.9-19.921,9.052a36.037,36.037,0,0,0,21.205,6.786C122.363,426.233,129.633,414.48,132.311,403.635Z",
    transform: "translate(-86.38 -258.955)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47905",
    "data-name": "Path 47905",
    d: "M138.216,262.26s-11.305,20.345-9.5,23.507,19.9,22.611,19.9,22.611S97.066,385.238,92.1,392.92s-5.877,18.988-3.635,25.325,15.825,12.2,25.325,11.754,16.722-12.214,19.388-23.023,27.191-90.5,29.457-96.792,5.416-11.305,2.254-14.468S149.521,280.8,149.521,280.8s3.635-3.163,3.163-6.786S144.541,263.157,138.216,262.26Z",
    transform: "translate(-30.724 -173.622)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47906",
    "data-name": "Path 47906",
    d: "M135.3,270.47l-2.254,5.489,6.786,3.163.291.363",
    transform: "translate(-21.038 -171.884)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47907",
    "data-name": "Path 47907",
    d: "M246.1,341.4s4.071-6.786,9.052-8.591,24.416-3.635,32.1-.909,12.2,12.663,13.559,18.079.909,13.123-3.635,17.182-10.4,3.175-16.734,1.357-18.988-9.039-25.773-13.111S246.56,344.1,246.1,341.4Z",
    transform: "translate(2.897 -159.171)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47908",
    "data-name": "Path 47908",
    d: "M201.507,333.419s-35.722,29.4-40.69,32.1-2.714,7.694-.909,9.5,13.559,12.663,18.988,16.273,13.111-2.714,14.916-3.635-.448-4.98-.448-4.98,14.02-7.682,16.273-14.916a81.67,81.67,0,0,0,2.714-17.182S269.3,373.6,282.886,378.6s22.15,5.429,28.488-.9,6.774-19.448,3.635-26.222-23.023-13.111-32.1-13.111-73.249-7.694-77.308-6.337Z",
    transform: "translate(-15.798 -158.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8682",
    "data-name": "Group 8682",
    transform: "translate(142 172.995)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47909",
    "data-name": "Path 47909",
    d: "M308.691,376.183a18.891,18.891,0,0,0,4.58-8.64c-23.786-1.466-93.557-27.87-100.573-28.33-8-.533-9.064,11.729-17.073,21.811s-12.747,12.844-19.666,13.911c-4.726.727-5.477,6.664-5.489,10.372,2.181,1.805,4.229,3.417,5.756,4.435,5.429,3.635,13.111-2.714,14.916-3.635s-.448-4.98-.448-4.98,14.02-7.682,16.273-14.916a81.671,81.671,0,0,0,2.714-17.182s56.951,23.023,70.534,28.027S302.354,382.508,308.691,376.183Z",
    transform: "translate(-155.116 -330.328)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47910",
    "data-name": "Path 47910",
    d: "M308.691,376.183a18.891,18.891,0,0,0,4.58-8.64c-23.786-1.466-93.557-27.87-100.573-28.33-8-.533-9.064,11.729-17.073,21.811s-12.747,12.844-19.666,13.911c-4.726.727-5.477,6.664-5.489,10.372,2.181,1.805,4.229,3.417,5.756,4.435,5.429,3.635,13.111-2.714,14.916-3.635s-.448-4.98-.448-4.98,14.02-7.682,16.273-14.916a81.671,81.671,0,0,0,2.714-17.182s56.951,23.023,70.534,28.027S302.354,382.508,308.691,376.183Z",
    transform: "translate(-155.116 -330.328)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47912",
    "data-name": "Path 47912",
    d: "M201.507,333.419s-35.722,29.4-40.69,32.1-2.714,7.694-.909,9.5,13.559,12.663,18.988,16.273,13.111-2.714,14.916-3.635-.448-4.98-.448-4.98,14.02-7.682,16.273-14.916a81.67,81.67,0,0,0,2.714-17.182S269.3,373.6,282.886,378.6s22.15,5.429,28.488-.9,6.774-19.448,3.635-26.222-23.023-13.111-32.1-13.111-73.249-7.694-77.308-6.337Z",
    transform: "translate(-15.798 -158.883)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_510",
    "data-name": "Line 510",
    x1: 5.877,
    y2: 2.714,
    transform: "translate(171.689 223.817)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47913",
    "data-name": "Path 47913",
    d: "M200.96,341.7l2.254,7.682,6.337,3.163-3.623-14.916Z",
    transform: "translate(-6.66 -157.665)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 10.627,
    cy: 8.361,
    rx: 10.627,
    ry: 8.361,
    transform: "translate(182.994 169.12)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_511",
    "data-name": "Line 511",
    x2: 487.985,
    transform: "translate(0 256.34)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximumNumberExceededCode);
export default __webpack_public_path__ + "static/media/maximum_number_exceeded_code.30882395adf38395d6a6a9339095f901.svg";
export { ForwardRef as ReactComponent };